import Toast from '../../components/Toast';
import styles from './DriverShell.module.css';

export default function DriverShell({ children }) {
  return (
    <div className={styles.shell}>
      <div className={styles.page}>{children}</div>
      <Toast />
    </div>
  );
}
